import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0baed0d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "log"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "signin/record"
}, "签到记录")], -1));
const _hoisted_2 = {
  class: "tk-tiems-box"
};
const _hoisted_3 = {
  class: "tk-prompt-cont"
};
const _hoisted_4 = {
  class: "tk-prompt-title"
};
const _hoisted_5 = {
  class: "tk-tiems-calendar"
};
const _hoisted_6 = {
  class: "tk-calendar-header"
};
const _hoisted_7 = {
  class: "tk-calendar-day"
};
const _hoisted_8 = {
  class: "tk-calendar-date"
};
import nav_header from '@/components/nav_header.vue';
import { punch_num, punch } from '@/util/http';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import { onBeforeMount } from 'vue';

import { reactive, toRefs } from 'vue';
export default {
  __name: 'signin',
  setup(__props) {
    let tiems = reactive({
      year: '',
      month: '',
      dates: '',
      days: '',
      signin: [],
      daysList: [],
      userInfo: {}
    });
    let {
      year,
      month,
      dates,
      days,
      daysList,
      qiandao,
      userInfo
    } = toRefs(tiems);
    let datas = () => {
      var date = new Date();
      tiems.year = date.getFullYear(); //获取完整的年份(4位)
      tiems.month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      tiems.dates = date.getDate(); //获取当前日(1-31)
      var d = new Date(tiems.year, tiems.month, 0);
      var days = d.getDate();
      tiems.days = days;
      for (let i = 1; i <= tiems.days; i++) {
        tiems.daysList.push({
          num: i,
          icon: 0
        });
      }
    };
    tiems.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    datas();
    onBeforeMount(() => {
      num();
    });
    let num = () => {
      punch_num().then(res => {
        let data = res.data;
        data.forEach(item => {
          tiems.signin.push(item.create_time.split('-')[2]);
        });
        tiems.signin.forEach(item => {
          tiems.daysList.forEach(items => {
            if (item == items.num) {
              items.icon = 1;
            }
          });
        });
      });
    };
    let signin = () => {
      punch().then(res => {
        num();
        tiems.userInfo.is_punch = '已签到';
        showToast(res.message);
        if (res.message != '已签到,请勿重复签到') {
          tiems.daysList.forEach(item => {
            if (item.num == tiems.dates) {
              item.icon = 1;
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "签到"
      }, {
        more: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "已签到" + _toDisplayString(_unref(userInfo).punch_num) + "天", 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_unref(year)) + "-" + _toDisplayString(_unref(month)), 1)]), _createElementVNode("div", _hoisted_7, "今天：" + _toDisplayString(_unref(year)) + "-" + _toDisplayString(_unref(month)) + "-" + _toDisplayString(_unref(dates)) + " " + _toDisplayString(_unref(userInfo).is_punch), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(daysList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(item.icon == 1 ? 'acitve' : ''),
          key: index
        }, _toDisplayString(item.num), 3);
      }), 128))])])]), _createElementVNode("div", {
        class: "submit",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(signin) && _unref(signin)(...args))
      }, " 点击签到 ")])], 64);
    };
  }
};